<template>
  <div id="more-features-dark" class="container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row-title" title="Great features">What can we do for you ?</div>
        </div>
      </div>
      <div class="row">

        <!--   加载详情页     -->
        <div class="col-sm-6 col-md-4" v-for="(item,key) in plugins">
          <div class="mfeature-box">
            <div class="mfeature-icon">
              <div class="icon-img"><img :src="item.image" :alt="item.title"></div>
            </div>
            <div class="mfeature-title"><a class="link" :href="item.url">{{item.title}}</a></div>
            <div class="mfeature-title" style="font-size: 13px;">
              <div v-if="item.webStoreLink">
                <a class="link" target="_blank" :href="item.webStoreLink">{{item.description}}</a>
              </div>
              <div v-else>
                {{item.description}}
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

// 介绍内容
import pic1 from "@/assets/picture/icon/qr_code.png";
import p_short_url from "@/assets/picture/icon/short_url.png";

export default {


  name: 'HomeView',

  setup(){
    const plugins=[{
      title:"Generate QR code",
      url:"/qrcode/apikey",
      webStoreLink:"https://chrome.google.com/webstore/detail/qr-code/geabiifdkhmcmhjgoagmlnlgnddooejf?hl=en",
      description:"Install from chrome store",
      image: pic1
    },
      {
        title:"Generate Short Url",
        url:"/shorturl/create",
        webStoreLink:"", // 暂时不填写
        description:"Use our URL Shortener to create a shortened link making it easy to remember",
        image: p_short_url
      }]

    return {plugins}
  }

}
</script>

<style scoped>
.link{
  text-decoration: none;
  color: #ffffff;
}
</style>
